import { useEffect } from 'react';

const useAdminLoginShortcut = (onToggle) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Check if user is typing in an input field
      const isTyping = ['INPUT', 'TEXTAREA']?.includes(e?.target?.tagName) || 
                       e?.target?.isContentEditable;
      
      if (isTyping) return;

      // Check for Cmd+Shift+L (Mac) or Ctrl+Shift+L (Windows/Linux)
      const isMac = navigator?.platform?.toUpperCase()?.indexOf('MAC') >= 0;
      const modifierKey = isMac ? e?.metaKey : e?.ctrlKey;
      
      if (modifierKey && e?.shiftKey && e?.key?.toLowerCase() === 'l') {
        e?.preventDefault();
        onToggle();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onToggle]);
};

export default useAdminLoginShortcut;